import { Report, ReportStatusLabel } from 'domain/usecases/get-report'
import { chevronForwardOutline, documentTextOutline } from 'ionicons/icons'
import { route } from 'main/routes'
import { FlexGrid } from 'presentation/components'
import ActionItem from 'presentation/components/action-item/action-item'
import MarkerRead from 'presentation/components/marker-read/marker-read'
import React from 'react'
import { useHistory } from 'react-router'
import './reports-item.scss'
type ReportsItemProps = {
  reportItem: Report
  index: number
  onClick: () => void
}

export const ReportsItem: React.FC<ReportsItemProps> = (props) => {
  const navigate = useHistory()
  return (
    <tr className={`reports-item ${props.reportItem.read === false ? 'not-read' : ''}`}>
      <td className="pi-marker-flex">
        <MarkerRead read={props.reportItem.read} />
        <b><small className="report-id">{props.reportItem.report_id}</small></b>
      </td>
      <td>
        <div>
          <b>{props.reportItem.patient?.name}</b>
          <br />
          <small>MRN: {props.reportItem.patient?.MRN}</small>
        </div>
      </td>
      <td>
        <span>{props.reportItem.patient?.cancer_type}</span>
      </td>
      <td>
        <span>{props.reportItem.patient?.treatment || '-'}</span>
      </td>
      <td>
        <span
          className={`badge status-${props.reportItem.status}`}
        >{ReportStatusLabel[props.reportItem.status] || '-'}</span>
      </td>
      <td>
        <span>{props.reportItem.doctor_name || '-'}</span>
      </td>
      <td>
        <FlexGrid gap={4}>
          {
            <>
              <ActionItem
                tooltip="View Report"
                icon={documentTextOutline}
                onClick={() => {
                  navigate.push(`${route.report.url}/${props.reportItem.report_id}`, props.reportItem)
                  props.onClick()
                }}
              />

              <ActionItem
                icon={chevronForwardOutline}
                tooltip="Patient Details"
                onClick={() => {
                  navigate.push(`${route.patient.url}`, {
                    patientItem: props.reportItem.patient,
                  })
                  props.onClick()
                }}
              />

            </>
          }
        </FlexGrid>
      </td>
    </tr>
  )
}

export default ReportsItem
